// extracted by mini-css-extract-plugin
export default {"fp_container":"Spiner_fp_container__OlHmy","fp_loader":"Spiner_fp_loader__j52i6"};